import { useEffect } from "react";

import { useResizeObserver } from "utilities/resizeObserver/useResizeObserver";

export const useGridContainerStickyHeight = (cssVariableName: string) => {
    const [, onHeightRefChange] = useResizeObserver<HTMLDivElement>((entry) => {
        // Prevent updates if entry is missing or element is removed from DOM
        // (prevents CI test errors when ResizeObserver fires after test teardown)
        if (!entry || !entry.target.isConnected) return;

        const height = entry.target.getBoundingClientRect().height || 0;
        document.documentElement.style.setProperty(cssVariableName, `${height}px`);
    });

    // Reset CSS variable on unmount
    useEffect(() => {
        return () => {
            document.documentElement.style.setProperty(cssVariableName, `0px`);
        };
    }, [cssVariableName]);

    return onHeightRefChange;
};
